import React, { useState } from "react"
import { Table, Button } from "react-bootstrap"
import { useSelector } from "react-redux"
import _ from "lodash"

import routes from "@/routes"
import { isBlank } from "@/utils"
import CruiseLineOnly from "@/auth_descriptor/CruiseLineOnly"
import ProcurementOnly from "@/auth_descriptor/ProcurementOnly"
import OperatorOnly from "@/auth_descriptor/OperatorOnly"
import { getStatus } from "@/insurance/features/helpers"
import StatusIcon from "@/insurance/features/StatusIcon"
import { getStatusLabels } from "@/insurance/features/dashboard/selectors"

import CertificateTable from "./CertificateTable"

const insuranceCategories = (profiles) =>
  _(profiles)
    .flatMap(({ profile }) => profile.insuranceCategories)
    .uniqWith((a, b) => a.categoryName === b.categoryName)
    .value()

const InsuranceTableRow = ({ company, allCategories }) => {
  const [expanded, setExpanded] = useState(false)

  const toggleRows = () => {
    setExpanded(!expanded)
  }

  const statusLabels = useSelector(getStatusLabels)

  const operatorData = (
    <tr key={company.name} className="cursor-pointer">
      <td onClick={toggleRows}>
        <span>{company.name}</span>
      </td>
      <CruiseLineOnly>
        <td onClick={toggleRows}>
          {_.map(company.regions, (region) => (
            <>
              <span key={region.name}>{region.name}</span>
              <br />
            </>
          ))}
        </td>
      </CruiseLineOnly>
      {allCategories.map((insuranceCategory) => {
        const relevantCategory = _.find(
          company.profile.insuranceCategories,
          (category) => category.categoryName === insuranceCategory.categoryName
        )

        if (isBlank(relevantCategory)) {
          return <th key={insuranceCategory.categoryName} />
        }

        return (
          <th
            onClick={toggleRows}
            key={relevantCategory.categoryName}
            scope="col"
            className="text-nowrap"
          >
            <StatusIcon
              status={getStatus(relevantCategory.insuranceStatus)}
              label={_.startCase(statusLabels[relevantCategory.insuranceStatus])}
            />
            <span className="ms-2">
              {getStatus(relevantCategory.insuranceStatus) != "unrequired" &&
                _.startCase(statusLabels[getStatus(relevantCategory.insuranceStatus)])}
            </span>
          </th>
        )
      })}
      <td>
        <ProcurementOnly>
          <Button
            href={routes.operator_profile_insurances_path({
              operator_profile_id: company.profile.id,
              _options: true,
            })}
          >
            Review
          </Button>
        </ProcurementOnly>
        <OperatorOnly>
          <Button
            href={routes.operator_profile_insurances_path({
              operator_profile_id: company.profile.id,
              _options: true,
            })}
          >
            View Profile
          </Button>
        </OperatorOnly>
      </td>
    </tr>
  )

  if (!expanded) {
    return operatorData
  }

  return (
    <>
      {operatorData}
      <tr>
        <td colSpan={allCategories.length + 3} className="p-0">
          <CertificateTable insuranceUploads={company.profile.insuranceUploads} />
        </td>
      </tr>
    </>
  )
}

const InsuranceTable = ({ profiles }) => {
  const allCategories = insuranceCategories(profiles)

  return (
    <Table responsive size="sm" className="align-items-center mb-5">
      <thead className="thead-light">
        <tr>
          <CruiseLineOnly>
            <th scope="col">Tour Operator</th>
          </CruiseLineOnly>
          <OperatorOnly>
            <th scope="col">Cruise Line</th>
          </OperatorOnly>
          <CruiseLineOnly>
            <th scope="col">Region</th>
          </CruiseLineOnly>
          {_.isEmpty(profiles) ? (
            <th />
          ) : (
            _.map(allCategories, ({ categoryName, categoryShortName }) => (
              <th key={categoryName} scope="col">
                {categoryShortName}
              </th>
            ))
          )}
          <th />
        </tr>
      </thead>
      <tbody>
        {_.isEmpty(profiles) ? (
          <tr>
            <td colSpan={4}>No companies found</td>
          </tr>
        ) : (
          profiles.map((company) => (
            <InsuranceTableRow key={company.name} company={company} allCategories={allCategories} />
          ))
        )}
      </tbody>
    </Table>
  )
}

export default InsuranceTable
